<a class="user-block no-drag" [routerLink]="!utils.isDesktop ? link : null">
  <div
    class="user-block__img"
    [class.image-border]="!imgSrc"
    [style.width]="imgSize"
    [style.height]="imgSize"
    [style.borderRadius]="imgSize === UserDataImgSize.s ? UserDataImgBorder.s : UserDataImgBorder.m"
  >
    <app-image [img]="imgSrc | addBaseUrl"></app-image>
  </div>
  <div class="user-block__title">
    <div class="user-block__title_name-wrap">
      <a [routerLink]="utils.isDesktop ? link : null" class="nav-link user-block__title_name-link">
        @if (dateEmployment | yearsOfServiceBadgeIcon; as badgeIcon) {
          <app-svg
            [icon]="badgeIcon"
            class="user-block__title__years_of_service_badge"
          ></app-svg>
        }
        @if (fullName) {
          <app-text
            [text]="fullName"
            (click)="onClick()"
            class="user-block__title_name"
            [ngClass]="{ 'user-block__title_name-active': isActive }"
          ></app-text>
        }
      </a>
    </div>
    <div>
      @if (position) {
        <app-text
          [textType]="TextType.base"
          [textSize]="TextSizes.mobPost"
          [text]="position"
        ></app-text>
      }
    </div>
    @if (date) {
      <div>
        @if (date) {
          <app-text
            [textType]="TextType.base"
            [textSize]="TextSizes.date"
            [text]="date | dateFormat"
          ></app-text>
        }
      </div>
    }
    @if (email) {
      <div class="additional-information">
        @if (email) {
          <div class="additional-information__item">
            <img src="assets/images/icons-svg/email.svg" />
            <a [href]="'mailto:' + email">
              <app-text
                [textType]="TextType.base"
                [textSize]="TextSizes.mobInput"
                [text]="email"
              ></app-text>
            </a>
          </div>
        }
      </div>
    }
  </div>
</a>
